import React, { useState } from 'react';
import { Modal, ModalHeader, ModalBody, Box, Text } from '@spothero/ui';
import { UpcomingEvents } from '../../landing/UpcomingEventsLanding';
import { NotGoingToEvent } from '../../not-going-to-event/NotGoingToEvent';
import { useDispatch, useSelector } from 'react-redux';
import { useShowEventsData } from 'pages/search/hooks/use-show-events-data';
import { setSearchComponentEventView, setSearchComponentIsOpen, } from 'store/search/search-actions';
import useIsMobile from 'hooks/use-is-mobile';
import { useAddHideEventModal } from 'utils/url/add-hide-event-modal/add-hide-event-modal';
export const EventsPopup = () => {
    const { showSEMEvent } = useShowEventsData();
    const eventView = useSelector((state) => state.search.data.searchComponentEventView);
    const showByButton = eventView === 'selectWFilter';
    const [modalOpen, setModalOpen] = useState(showSEMEvent);
    const destinationTitle = useSelector((state) => state.destination.data.title);
    const dispatch = useDispatch();
    const isMobile = useIsMobile();
    const addHideEventModal = useAddHideEventModal();
    const handleHide = () => {
        setModalOpen(false);
        dispatch(setSearchComponentEventView(null));
        dispatch(setSearchComponentIsOpen(false));
        addHideEventModal(); // Add hide event modal to query params
    };
    if (isMobile) {
        return <div date-testid="desktop-events-popup-hidden"/>;
    }
    return (<Modal hasHeader size="md" isOpen={showByButton || modalOpen} onClose={handleHide}>
            <ModalHeader>
                Find and reserve parking near {destinationTitle}
            </ModalHeader>
            <ModalBody>
                <Box flex={{ desktop: '1 1 50%' }} display="grid" gridTemplateRows="min-content" borderRight="1px solid var(--chakra-colors-gray-200)" paddingRight="8" sx={{
            'a svg': {
                color: 'black',
            },
        }}>
                    <Text fontWeight="medium" fontSize="sm" paddingTop="4">
                        Upcoming Events
                    </Text>
                    <UpcomingEvents pageSize={5}/>
                </Box>
                <Box flex={{ desktop: '1 1 auto' }} paddingLeft="8" sx={{
            'a svg': {
                color: 'black',
            },
        }}>
                    <NotGoingToEvent />
                </Box>
            </ModalBody>
        </Modal>);
};
